import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StripeHealthResponse } from '@umss/shared/data-access';

@Injectable({ providedIn: 'root' })
export class StripeHealthService {
  private readonly baseUrl = 'api/stripe';

  private readonly http = inject(HttpClient);

  getHealth(): Observable<StripeHealthResponse> {
    return this.http.get<StripeHealthResponse>(`${this.baseUrl}/health`);
  }
}
